import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {TopnavbarComponent} from "./topnavbar.component";
import {GlobLiveSearchModule} from "../../glob-search/module";
import {FloatingButtonModule} from "../../../modules/floating-button/module";


@NgModule({
    declarations: [TopnavbarComponent],
    imports     : [BrowserModule, GlobLiveSearchModule, FloatingButtonModule],
    exports     : [TopnavbarComponent],
})

export class TopnavbarModule {}


// WEBPACK FOOTER //
// ./src/app/components/common/topnavbar/topnavbar.module.ts